module.exports = __webpack_public_path__ + "silla-negra.png?5ab893e05a7a8b5c7b81d0535fb47d48";


//////////////////
// WEBPACK FOOTER
// ./src/images/silla-negra.png
// module id = 530
// module chunks = 0